import { Component, OnInit } from '@angular/core';
import { AppStorage } from '../providers/enum';
import { StorageService } from '../shared/services/storage.service';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';
import { StreamDetailsService } from '../shared/services/stream-details.service';
import { CanonicalService } from '../shared/services/canonical.service';
@Component({
  selector: 'app-pages',
  template: `
  <div *ngIf="!showLoading">
    <app-header [result]="result" *ngIf="!isSingleSwigIt"></app-header>
    <div id="page-content">
      <router-outlet></router-outlet>
    </div>
    <app-footer [streamDetailsFull]="result" *ngIf="!isSingleSwigIt"></app-footer>
  </div>
  
  <app-spinner *ngIf="showLoading">
  </app-spinner>`,
  styleUrls: ['./pages.component.scss']
})
export class PagesComponent implements OnInit {


  //#region variables

  public showLoading: boolean = true;
  public streamDetailsFull: any;
  public result: any;
  public appDetails1: any;
  public domain: string;
  public title: string;
  public clientPage: boolean = true;
  public chanallHomePage: boolean = true;
  public bundlePage: boolean = true;
  public isSingleSwigIt: boolean = false;
  public userData: any;
  public streamDetails: any;
  public streamCorrect: boolean;
  //#endregion

  //#region life-cycle hook

  constructor(private router: Router,
    private route: ActivatedRoute,
    private storageService: StorageService,
    private streamDetailsService: StreamDetailsService,
    private location: Location,
    private titleService: Title,
    private metaTagService: Meta,
    private canonicalService: CanonicalService,
  ) {

    if(document.location.host == "localhost:4200")
    {
        // LOCAL SERVER


        this.route.queryParams.subscribe(params => {
          //console.log("innn=", params);
          //alert(params.domain +"-"+params.title);
          if (params && params.domain) {
            let localDomainvar = params.domain;
            let localTitlevar = params.title;
            this.title = params.title;
            this.domain = params.domain;
            let urlR = this.router.url.substring(0, 4);
            //alert(urlR);
            //console.log("urlR=", urlR);
            if (localTitlevar.toLowerCase().indexOf('-sm') !== -1) {
              this.title = localTitlevar.substring(0, localTitlevar.toLowerCase().indexOf('-sm'));
              //console.log("skinny domain: ",this.domain);
             // console.log("bundle title: ", this.title);
              this.clientPage = false;
              this.bundlePage = true;
              this.chanallHomePage = false;
              this.isSingleSwigIt = false;
            }
            else {
              
              if (urlR === '/app') 
              {
                this.clientPage = false;
                this.bundlePage = false;
                this.chanallHomePage = false;
                this.isSingleSwigIt = true;
              //  console.log("single swigit domain: /app",this.domain);
              }
              else if (this.domain != "") 
              {
               
                // console.log("client domain: ",this.domain);
                // console.log(" domain1: ", this.domain);
                this.clientPage = true;
                this.chanallHomePage = false;
                this.bundlePage = false;
                this.isSingleSwigIt = false;
                // console.log(" domain2: ", this.domain);
              }
              else {
                
                this.domain = "";
                this.chanallHomePage = true;
                this.clientPage = false;
                this.bundlePage = false;
                this.isSingleSwigIt = false;
              }
            }
    
          }
         
         
    
        }, (error: any) => {
          // console.log('error: ', error);
        });
    }
    else
    {
        // LIVE SERVER
        let url = this.router.url.substring(0, 4);
      if (url === '/app') 
      {
        let apptitlel = this.route.snapshot.params.apptitle;
        this.title = apptitlel;

        let swigtitle1 = this.location.path();
        let swigtitleArr = swigtitle1.split("/");
        this.title = swigtitleArr[2];
        this.isSingleSwigIt = true;
       // console.log("in app: ");

        let titleVal = this.title;
        let titleValArr = titleVal.split("?");
        if(titleValArr.length > 0 )
        {
          this.title = titleValArr[0];
        }
      } 
      else 
      {
        let bundletitle1 = this.location.path();
        let bundTitleArr = bundletitle1.split("=");
        this.title = bundTitleArr[1];
        this.isSingleSwigIt = false;
       // console.log("in bundle: ");
      }
     // console.log("main title from url: ",this.title);
      //console.log("router url: ",this.router.url);
      //console.log("url apptitle: ", this.title);

      let fullHost = document.location.host + "/" + this.location.path();
      

      
      // this.DomainName = document.location.host;
     // console.log("fullhost=",  this.location.path());
     // console.log("fullhost=",  fullHost);

      // let fullHost = "c2c.swigit.com";
      let parts = fullHost.split('.');
      if (parts && parts.length > 0 && parts[0] !== "localhost") 
      {
        let url = this.router.url;
        let domainNm = parts[0];
        this.domain = parts[0];

        if (this.title.toLowerCase().indexOf('-sm') !== -1) 
        {
          this.domain = parts[0];
          this.title = this.title.substring(0, this.title.toLowerCase().indexOf('-sm'));
         // console.log("skinny domain: ",this.domain);
         // console.log("skinny title: ",this.title);

          this.clientPage = false;
          this.bundlePage = true;
          this.chanallHomePage = false;
        }
        else {
          this.domain = parts[0];

          if (this.domain == "main") {
            this.chanallHomePage = true;
            this.bundlePage = false;
            this.clientPage = false;
          }
          else {
            //console.log("client domain: ",this.domain);
            //console.log(" domain: ",this.domain);
            this.chanallHomePage = false;
            this.bundlePage = false;
            this.clientPage = true;
          }
        }


      }

    }

   
    //let apptitlel = this.route.snapshot.params.apptitle;
    //this.title = apptitlel;

    


    // console.log("url param: ",this.route.snapshot.params);
    // console.log("url apptitle: ", apptitlel);
    

    // This code for localhost

    

    //console.log("domain=", this.domain);
    //console.log("title=", this.title);

   

    //this.chanallHomePage = true;
    this.storageService.set(AppStorage.siteDomain, this.domain, true);
    this.storageService.set(AppStorage.siteTitle, this.title, true);

  }

  ngOnInit(): void {
    //console.log('this.chanallHomePage=: ', this.chanallHomePage);
    //console.log('this.clientPage=: ', this.clientPage);
    //console.log('this.isSingleSwigIt=: ', this.isSingleSwigIt);
    //console.log('this.bundlePage=: ', this.bundlePage);
    this.setMetaData();
    //this.setStreamDetails();
    if (this.chanallHomePage)
      this.setChanallDetails();
    else if (this.clientPage)
      this.setClientDetails();
    else if (this.bundlePage)
      this.setBundleDetails();
    else
      this.setStreamDetails();
  }

  //#endregion

  //#region private methods

  private async setChanallDetails() {
    try {
      let result = await this.streamDetailsService.getChanallDetails().toPromise();
      // console.log("page result=", result);
      if (result.app.status) {
        result["HomePageVar"] = true;
        result["ClientPageVar"] = false;
        this.storageService.set(AppStorage.chanallDetails, JSON.stringify(result), true);
        //   this.appDetails1 = result.data.appDetails;
        //   this.storageService.set(AppStorage.appDetailsStorage, JSON.stringify(this.appDetails1), true);
        //   this.storageService.set(AppStorage.appCodeLS, this.appDetails1.appCode, true);
        //   console.log("appCode=", result);

        this.result = result;
        this.showLoading = false;

      }
    } catch (error) {
      // console.log('error: ', error);
      this.showLoading = false;
    }
    // console.log("header storage details: ", this.storageService.get(AppStorage.clientDetails, true));
    // this.isWatchEventDisable = false;
  }

  private async setClientDetails() {
    try {
      let result = await this.streamDetailsService.getClientDetails().toPromise();
      // console.log("page result=", result);
      if (result.status) {
        result["ClientPageVar"] = this.clientPage;
        result["HomePageVar"] = false;
        this.storageService.set(AppStorage.clientDetails, JSON.stringify(result), true);
        this.appDetails1 = result.data.appDetails;
        this.storageService.set(AppStorage.appDetailsStorage, JSON.stringify(this.appDetails1), true);
        this.storageService.set(AppStorage.appCodeLS, this.appDetails1.appCode, true);
        // console.log("qqqqqqqqqappCode=", this.appDetails1.appCode);

        this.result = result;
        this.showLoading = false;

      }
    } catch (error) {
      // console.log('error: ', error);
      this.showLoading = false;
    }
    // console.log("header storage details: ", this.storageService.get(AppStorage.clientDetails, true));
    // this.isWatchEventDisable = false;
  }

  private async setBundleDetails() {
    try {
      let result = await this.streamDetailsService.getBundleDetails().toPromise();
      //console.log("page result=", result);
      if (result.status) {
        result["ClientPageVar"] = this.clientPage;
        result["HomePageVar"] = false;
        this.storageService.set(AppStorage.clientDetails, JSON.stringify(result), true);
        this.appDetails1 = result.data.appDetails;
        this.storageService.set(AppStorage.appDetailsStorage, JSON.stringify(this.appDetails1), true);
        this.storageService.set(AppStorage.appCodeLS, this.appDetails1.appCode, true);
        //console.log("appCode=", this.appDetails1.appCode);

        this.result = result;
        this.showLoading = false;

      }
    } catch (error) {
      // console.log('error: ', error);
      this.showLoading = false;
    }
    // console.log("header storage details: ", this.storageService.get(AppStorage.clientDetails, true));
    // this.isWatchEventDisable = false;
  }

  private async setStreamDetails() {
    let data = this.storageService.get(AppStorage.data, true);
    this.userData = JSON.parse(data);
    this.streamCorrect = true;
    try {
      let result = await this.streamDetailsService.getStreamDetails().toPromise();

      //console.log("stream detail:", result);
      if (result.app.status) {
        // console.log("inn");
        result["ClientPageVar"] = this.clientPage;
        result["HomePageVar"] = false;
        this.storageService.set(AppStorage.appCodeLS, result.app.all_streams.latest_streams[0].appCode, true);
        this.streamDetailsFull = result.app.all_streams.latest_streams[0];
        //this.streamType = this.streamDetailsFull.stream_type;

        this.result = result;
        this.showLoading = false;

      }

    }
    catch (error) {
      //console.log('error: ', error);
      this.showLoading = false;
      this.streamCorrect = false;
    }


    // this.isWatchEventDisable = false;
  }

  private setMetaData() {
    if (this.isSingleSwigIt)
      this.setSingleSwigItMetaDataDetails();
    else if (this.chanallHomePage)
      this.setChanallMetaDataDetails();
    else if (this.clientPage)
      this.setClientMetaDataDetails();
    else if (this.bundlePage)
      this.setBundleMetaDataDetails();
  }

  private async setSingleSwigItMetaDataDetails() {
    try {
      let result = await this.streamDetailsService.getSingleSwigItMetaDataDetails().toPromise();
      if (result.status) {
        this.canonicalService.setIcon(result.data.metadata.meta_fav);
        this.canonicalService.setShortcutIcon(result.data.metadata.meta_fav);
        this.canonicalService.setAddressBarIcon(result.data.metadata.meta_fav);
        this.canonicalService.setAppleTouchIcon(result.data.metadata.meta_fav);
        this.titleService.setTitle(result.data.metadata.meta_title);
        this.metaTagService.addTags([
          { name: 'name', content: result.data.metadata.meta_title },
          { name: 'description', content: result.data.metadata.meta_description },
          { name: 'image', content: result.data.metadata.meta_poster },
          { name: 'og:url', content: result.data.metadata.meta_ogurl },
          { name: 'og:type', content: "website" },
          { name: 'og:title', content: result.data.metadata.meta_title },
          { name: 'og:description', content: result.data.metadata.meta_description },
          { name: 'og:image', content: result.data.metadata.meta_poster },
          { name: 'og:image:secure_url', content: result.data.metadata.meta_poster },
          { name: 'twitter:url', content: result.data.metadata.meta_ogurl },
          { name: 'twitter:title', content: result.data.metadata.meta_title },
          { name: 'twitter:description', content: result.data.metadata.meta_description },
          { name: 'twitter:image', content: result.data.metadata.meta_poster },
        ]);
      }
    }
    catch (error) {
      //console.log('error: ', error);
      this.showLoading = false;
      this.streamCorrect = false;
    }
  }

  private async setChanallMetaDataDetails() {
    try {
      let result = await this.streamDetailsService.getChanallMetaDataDetails().toPromise();
      if (result.status) {
        this.canonicalService.setIcon(result.data.metadata.meta_fav);
        this.canonicalService.setShortcutIcon(result.data.metadata.meta_fav);
        this.canonicalService.setAddressBarIcon(result.data.metadata.meta_fav);
        this.canonicalService.setAppleTouchIcon(result.data.metadata.meta_fav);
        this.titleService.setTitle(result.data.metadata.meta_title);
        this.metaTagService.addTags([
          { name: 'name', content: result.data.metadata.meta_title },
          { name: 'description', content: result.data.metadata.meta_description },
          { name: 'image', content: result.data.metadata.meta_poster },
          { name: 'og:url', content: result.data.metadata.meta_ogurl },
          { name: 'og:type', content: "website" },
          { name: 'og:title', content: result.data.metadata.meta_title },
          { name: 'og:description', content: result.data.metadata.meta_description },
          { name: 'og:image', content: result.data.metadata.meta_poster },
          { name: 'og:image:secure_url', content: result.data.metadata.meta_poster },
          { name: 'twitter:url', content: result.data.metadata.meta_ogurl },
          { name: 'twitter:title', content: result.data.metadata.meta_title },
          { name: 'twitter:description', content: result.data.metadata.meta_description },
          { name: 'twitter:image', content: result.data.metadata.meta_poster },
        ]);
      }
    }
    catch (error) {
      //console.log('error: ', error);
      this.showLoading = false;
      this.streamCorrect = false;
    }
  }

  private async setClientMetaDataDetails() {
    try {
      let result = await this.streamDetailsService.getClientMetaDataDetails().toPromise();
      if (result.status) {
        this.canonicalService.setIcon(result.data.metadata.meta_fav);
        this.canonicalService.setShortcutIcon(result.data.metadata.meta_fav);
        this.canonicalService.setAddressBarIcon(result.data.metadata.meta_fav);
        this.canonicalService.setAppleTouchIcon(result.data.metadata.meta_fav);
        this.titleService.setTitle(result.data.metadata.meta_title);
        this.metaTagService.addTags([
          { name: 'name', content: result.data.metadata.meta_title },
          { name: 'description', content: result.data.metadata.meta_description },
          { name: 'image', content: result.data.metadata.meta_poster },
          { name: 'og:url', content: result.data.metadata.meta_ogurl },
          { name: 'og:type', content: "website" },
          { name: 'og:title', content: result.data.metadata.meta_title },
          { name: 'og:description', content: result.data.metadata.meta_description },
          { name: 'og:image', content: result.data.metadata.meta_poster },
          { name: 'og:image:secure_url', content: result.data.metadata.meta_poster },
          { name: 'twitter:url', content: result.data.metadata.meta_ogurl },
          { name: 'twitter:title', content: result.data.metadata.meta_title },
          { name: 'twitter:description', content: result.data.metadata.meta_description },
          { name: 'twitter:image', content: result.data.metadata.meta_poster },
        ]);
      }
    }
    catch (error) {
      //console.log('error: ', error);
      this.showLoading = false;
      this.streamCorrect = false;
    }
  }

  private async setBundleMetaDataDetails() {
    try {
      let result = await this.streamDetailsService.getBundleMetaDataDetails().toPromise();
      if (result.status) {
        this.canonicalService.setIcon(result.data.metadata.meta_fav);
        this.canonicalService.setShortcutIcon(result.data.metadata.meta_fav);
        this.canonicalService.setAddressBarIcon(result.data.metadata.meta_fav);
        this.canonicalService.setAppleTouchIcon(result.data.metadata.meta_fav);
        this.titleService.setTitle(result.data.metadata.meta_title);
        this.metaTagService.addTags([
          { name: 'name', content: result.data.metadata.meta_title },
          { name: 'description', content: result.data.metadata.meta_description },
          { name: 'image', content: result.data.metadata.meta_poster },
          { name: 'og:url', content: result.data.metadata.meta_ogurl },
          { name: 'og:type', content: "website" },
          { name: 'og:title', content: result.data.metadata.meta_title },
          { name: 'og:description', content: result.data.metadata.meta_description },
          { name: 'og:image', content: result.data.metadata.meta_poster },
          { name: 'og:image:secure_url', content: result.data.metadata.meta_poster },
          { name: 'twitter:url', content: result.data.metadata.meta_ogurl },
          { name: 'twitter:title', content: result.data.metadata.meta_title },
          { name: 'twitter:description', content: result.data.metadata.meta_description },
          { name: 'twitter:image', content: result.data.metadata.meta_poster },
        ]);
      }
    }
    catch (error) {
      //console.log('error: ', error);
      this.showLoading = false;
      this.streamCorrect = false;
    }
  }

  //#endregion

}
